import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createWalletSlice = (set, get) => ({
    crmWallet: {
        loading: false,
        data: []
    },
    getCrmWallet: async (UsrUserID) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmWallet: { ...state.crmWallet, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/wallet/transaction-histories/${UsrUserID}`,
                headers: { token }
            });
            set(state => ({ crmWallet: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmWallet: { loading: false, data: [] } }));
        }
    }
});
